export const EmailOrPasswordIncorrectBox = () => {
  return (
    <div className='border border-gray-200 bg-error-25 shadows-xs h-[52px] flex gap-1 items-center p-4 text-sm'>
      Email or password is incorrect.
      <a
        href='https://zsupport.movingworlds.org/portal/en/kb/articles/i-can-t-login-and-or-have-password-issues-10-3-2023-1'
        className='underline text-brand-100'
      >
        Get more help
      </a>
    </div>
  );
};
